module.exports = __webpack_public_path__ + "img/logo-19.8b9be5c.jpg";